export default function ThinRec() {
  return (
    <div className=" w-c6 h-full border-r-2 border-solid border-gray-300 border-l-1   "></div>
  );
}
